import { render, staticRenderFns } from "./NoticeModerationForm.vue?vue&type=template&id=5b6f3aac&scoped=true&"
import script from "./NoticeModerationForm.vue?vue&type=script&lang=js&"
export * from "./NoticeModerationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f3aac",
  null
  
)

export default component.exports